if (!customElements.get('insight-image-switcher')) {
  class InsightImageSwitcher extends HTMLElement {
    connectedCallback() {
      this.navItems = Array.from(this.querySelectorAll('[data-iis-nav]'));
      this.bgs = Array.from(this.querySelectorAll('[data-iis-bg]'));
      this.leftCards = Array.from(this.querySelectorAll('[data-iis-left]'));
      this.indicator = this.querySelector('[data-iis-indicator]');
      this.list = this.querySelector('[data-iis-list]');
      this.activeIndex = this.navItems.findIndex(InsightImageSwitcher.isActiveItem);
      if (this.activeIndex < 0) this.activeIndex = 0;

      this.handleListClick = this.handleListClick.bind(this);
      this.handleListKeydown = this.handleListKeydown.bind(this);
      this.updateIndicator = this.updateIndicator.bind(this);
      this.scheduleIndicatorUpdate = this.scheduleIndicatorUpdate.bind(this);

      this.list?.addEventListener('click', this.handleListClick);
      this.list?.addEventListener('keydown', this.handleListKeydown);

      if (typeof ResizeObserver !== 'undefined' && this.list) {
        this.ro = new ResizeObserver(this.scheduleIndicatorUpdate);
        this.ro.observe(this.list);
      } else {
        window.addEventListener('resize', this.scheduleIndicatorUpdate);
      }

      this.scheduleIndicatorUpdate();
    }

    disconnectedCallback() {
      this.list?.removeEventListener('click', this.handleListClick);
      this.list?.removeEventListener('keydown', this.handleListKeydown);
      this.ro?.disconnect();
      window.removeEventListener('resize', this.scheduleIndicatorUpdate);
      if (this._indicatorRaf) cancelAnimationFrame(this._indicatorRaf);
    }

    static isActiveItem(item) {
      return item.classList.contains('is-active');
    }

    scheduleIndicatorUpdate() {
      if (this._indicatorRaf) cancelAnimationFrame(this._indicatorRaf);
      this._indicatorRaf = requestAnimationFrame(() => {
        this._indicatorRaf = null;
        this.updateIndicator();
      });
    }

    handleListClick(event) {
      const item = event.target.closest('[data-iis-nav]');
      if (!item || !this.list?.contains(item)) return;

      this.goTo(Number(item.dataset.index));
    }

    handleListKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const item = event.target.closest('[data-iis-nav]');
      if (!item || !this.list?.contains(item)) return;

      event.preventDefault();
      this.goTo(Number(item.dataset.index));
    }

    goTo(index) {
      if (index === this.activeIndex || !this.navItems[index]) return;

      this.navItems[this.activeIndex]?.classList.remove('is-active');
      this.bgs[this.activeIndex]?.classList.remove('is-active');
      this.leftCards[this.activeIndex]?.classList.remove('is-active');
      this.navItems[this.activeIndex]?.setAttribute('aria-pressed', 'false');

      this.activeIndex = index;

      this.navItems[index].classList.add('is-active');
      this.bgs[index]?.classList.add('is-active');
      this.leftCards[index]?.classList.add('is-active');
      this.navItems[index].setAttribute('aria-pressed', 'true');

      this.scheduleIndicatorUpdate();
    }

    updateIndicator() {
      if (!this.indicator || !this.navItems[this.activeIndex] || !this.list) return;

      const active = this.navItems[this.activeIndex];
      this.indicator.style.height = `${active.offsetHeight}px`;
      this.indicator.style.transform = `translateY(${active.offsetTop}px)`;
    }
  }

  customElements.define('insight-image-switcher', InsightImageSwitcher);
}
